/**
 * Browser fullscreen only paints the fullscreen element and its descendants.
 * Portals must therefore target the active fullscreen root rather than body.
 */
export function getFullscreenPortalTarget(): Element {
  const fullscreenElement =
    document.fullscreenElement ||
    (document as any).webkitFullscreenElement ||
    (document as any).mozFullScreenElement ||
    (document as any).msFullscreenElement;

  return fullscreenElement || document.body;
}
